import {postAsyncJobFetcher} from 'app/jobs/fetchers';
import {showNotification} from 'app/toasts/slice';
import {gt} from 'app/utils/i18n';
import {createErrorHandler} from 'app/utils/request';

import {userJobDispatcher} from './userJobDispatcher';

import type {AppDispatchType} from 'app/store/AppStore';

// needs full path to be replaced by demo-app webpack

interface AsyncJobProps {
  url: string;
  obj: any;
  errorText: string;
}

export const postAsyncJob =
  ({url, obj, errorText}: AsyncJobProps) =>
  (dispatch: AppDispatchType) =>
    dispatch(
      userJobDispatcher(
        postAsyncJobFetcher(url, obj).catch((err) => {
          createErrorHandler(gt(errorText), dispatch, {
            '403': (error) => {
              throw error;
            },
          });
          throw err;
        })
      )
    ).job.catch((err) => {
      if (err === 'multitask_job_error') {
        dispatch(showNotification(gt(errorText), 'error'));
      }
      // err can be an 400 error - let's bubble it up so the form can handle it
      throw err;
    });
